import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var RentersInsurance = Class.create({
  	initialize: function() {
	},
	getQuote: function(dob, callback) {
		var url = "tenant/rentersquote?dob=" + dob;
		var data = server.getData(url,null, true);
		data
		.done(function(response){
            if(response.status == 'ERROR') {
				jQuery("#login").attr('disabled', false);
            	jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
                modal.showInfo(response.message, "danger", "top", "center");
            }

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			jQuery("#login").attr('disabled', false);
            jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
    },
    reQuote: function(quoteId, materialType, dob, insuranceDetails, callback) {
		var url = "tenant/rentersquote";
		var params = {
			quoteId: quoteId,
            materialType: materialType,
			dob: dob,
			medicalCoverage: insuranceDetails.medicalCoverage,
			liabilityCoverage: insuranceDetails.liabilityCoverage,
			personalPropertyCoverage: insuranceDetails.personalPropertyCoverage,
			priorAddress: insuranceDetails.priorAddress,
			priorCity: insuranceDetails.priorCity,
			priorState: insuranceDetails.priorState,
			priorZip: insuranceDetails.priorZip,
			moreThanSixMonths: insuranceDetails.moreThanSixMonths
        };
		var data = server.getData(url, params, true, "PUT");
		data
		.done(function(response){
            if(response.status == 'ERROR') {
				jQuery("#login").attr('disabled', false);
            	jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
                modal.showInfo(response.message, "danger", "top", "center");
            }

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			jQuery("#login").attr('disabled', false);
            jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
    },
    purchase: function(data, paymentAccountId, paymentType, callback) {
		var url = "tenant/rentersquote/purchase";
		data['paymentAccountId'] = paymentAccountId;
		data['paymentType'] = paymentType;
		var data = server.getData(url, data, true, "POST");
		data
		.done(function(response){
            if(response.status == 'ERROR') {
				jQuery("#login").attr('disabled', false);
            	jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
                modal.showInfo(response.message, "danger", "top", "center");
            }

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			jQuery("#login").attr('disabled', false);
            jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
	getFinancialKey: function(data, callback) {
		var url = "tenant/rentersquote/financialKey";
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
            if(response.status == 'ERROR') {
				jQuery("#login").attr('disabled', false);
            	jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
                modal.showInfo(response.message, "danger", "top", "center");
            }

            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			jQuery("#login").attr('disabled', false);
            jQuery(".preLoader").css({display: 'none', background: 'rgb(58 155 242)'});
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
	getInsurance: function(callback) {
		var url = "tenant/rentersquote/policy";
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
            if(callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
});

export let rentersInsurance = new RentersInsurance();


// WEBPACK FOOTER //
// app/core/controllers/RentersInsurance.js